import CustomerInformation from './table/index.js';

export default CustomerInformation;
